module.exports = __webpack_public_path__ + "img/icon-nav-lk.f43175c7.svg";